<div class="make-payment-container">
    <div class="status-box">
        <div class="circle-outer">
            <div class="circle-inner">
                <i class="pi pi-check icon"></i>
            </div>
        </div>
        <h2 class="approved-title">Application is Approved</h2>
        <p class="approved-message">
            Congratulations! Your business details have been approved!
        </p>

        <div class="whats-next-box">
            <p class="whats-next-title">What’s next?</p>
            <ul class="whats-next-list">

                <li>Add money to your wallet for seamless transactions between you and Auto ECare</li>

                <li>We will automatically deduct the applicable amount once you start adding SP, SA, and customers.</li>

            </ul>

            <button class="add-payment-button" (click)="goToAddBalance()">Add Balance to Wallet </button>
        </div>
    </div>
</div>